import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as Sentry from '@sentry/react';

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem('isHost');
    sessionStorage.removeItem('hostToken');
  }, []);

  const createTvRoom = async () => {
    try {
      const serverUrl = import.meta.env.VITE_SERVER_URL || 'http://localhost:5000';
      const res = await axios.post<{ roomCode: string; hostToken: string }>(`${serverUrl}/api/create-room`);
      sessionStorage.setItem('hostToken', res.data.hostToken);
      sessionStorage.removeItem('isHost');
      navigate(`/host/${res.data.roomCode}`);
    } catch (err) {
      Sentry.captureException(err);
      if (import.meta.env.MODE !== 'production') {
        console.error('Error creating room:', err);
      }
      alert('Failed to create room. Please try again.');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <h1 className="text-4xl md:text-5xl font-bold mb-8 tracking-tight">maxbox.live</h1>
      <button
        onClick={() => navigate('/create')}
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg shadow-md transition duration-300 text-xl"
      >
        Create a Room
      </button>
      <button
        onClick={() => navigate('/join')}
        className="mt-4 bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-4 rounded-lg shadow-md transition duration-300 text-xl"
      >
        Join a Room
      </button>
      <button
        onClick={createTvRoom}
        className="mt-6 text-sm underline text-gray-300 hover:text-white"
      >
        Hosting on a TV instead?
      </button>
    </div>
  );
}

export default LandingPage;
